export default {
  title: 'News',
  newsLink: 'All the news',
};
